/** @jsx jsx */

import { css, jsx, keyframes } from '@emotion/core';
import { useSelector } from 'react-redux';
import { State } from 'store/store';

const dualRingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

interface ILoadingSpinnerProps {
  size?: number;
  color?: string | undefined;
  lineWeight?: number;
}

const LoadingSpinner = ({
  size = 46,
  color,
  lineWeight = 5,
}: ILoadingSpinnerProps) => {
  const loadingSpinnerColor = useSelector((state: State) => {
    return state.theme.loadingSpinnerColor || '#cea5f9';
  });

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      `}
    >
      <div
        css={css`
           {
            display: inline-block;
            width: ${size}px;
            height: ${size}px;
            animation: 1.2s linear infinite;
          }
          &:after {
            content: '';
            display: block;
            width: ${size - lineWeight * 2}px;
            height: ${size - lineWeight * 2}px;
            border-radius: 50%;
            border: ${lineWeight}px solid ${color};
            border-color: ${color} transparent ${color} transparent;
            animation: ${dualRingAnimation} 1.2s linear infinite;
          }
        `}
      />
    </div>
  );
};

export default LoadingSpinner;
